<template>
  <div>
    <div :class="{'c-sidebar__active-group': group === 'events'}">
      <router-link
        class="c-sidebar__item c-sidebar__item-main"
        exact :to="{ name: 'organisation.events'}">
        {{$t('events')}}
      </router-link>
    </div>
    <div :class="{'c-sidebar__active-group': group === 'organisation'}">
      <router-link
        exact class="c-sidebar__item c-sidebar__item-main c-sidebar__item-with-children"
        v-if="group !== 'organisation'"
        :to="{ name: 'organisation.settings'}">
        {{$t('organisation')}}
      </router-link>
      <template v-if="group === 'organisation'">
        <div class="c-sidebar__item c-sidebar__item-main c-sidebar__item-with-children c-sidebar__item-open">
          {{$t('organisation')}}
        </div>
        <router-link exact class="c-sidebar__item" :to="{ name: 'organisation.settings'}">
          {{$t('menu.organisationSettings')}}
        </router-link>
        <router-link exact v-if="orgRole === 'admin'" class="c-sidebar__item" :to="{ name: 'organisation.users'}">
          {{$t('menu.organisationUsers')}}
        </router-link>
        <router-link exact v-if="orgRole === 'admin'" class="c-sidebar__item" :to="{ name: 'organisation.passwords'}">
          {{$t('organisation.passwords')}}
        </router-link>
        <router-link exact class="c-sidebar__item" :to="{ name: 'organisation.planningDefaults'}">
          {{$t('menu.planningDefaults')}}
        </router-link>
        <router-link exact class="c-sidebar__item" :to="{ name: 'organisation.displayTemplates'}">
          {{$t('menu.displayTemplates')}}
        </router-link>
        <!-- TODO add member user admin -->
      </template>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'home-menu',
    data: function() {
      return {
        group: 'events',
      };
    },
    computed: {
      orgRole: function() {
        return this.$store.state.user.roles['organisation']
      },
      organisation: function() {
        // TODO use current organisation
        const orgId = this.$route.params.organisationId
        return this.$store.state.organisations.items.find(o => o.id === orgId)
      },
    },
    watch: {
      $route: {
        immediate: true,
        handler: function(to) {
          // const path = to.path;
          if (to.name.startsWith('organisation.events')) {
            this.group = 'events'
          }
          else if (to.name.startsWith('organisation.')) {
            this.group = 'organisation'
          }
          else {
            this.group = 'user'
          }
        },
      },
    },
  }
</script>
